import { render, staticRenderFns } from "./changeList.vue?vue&type=template&id=9e616fb6&scoped=true"
import script from "./changeList.vue?vue&type=script&lang=js"
export * from "./changeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e616fb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/dev-node-01/workspace/test-flight/tinggo/tinggo-vue-12765/server_app_code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e616fb6')) {
      api.createRecord('9e616fb6', component.options)
    } else {
      api.reload('9e616fb6', component.options)
    }
    module.hot.accept("./changeList.vue?vue&type=template&id=9e616fb6&scoped=true", function () {
      api.rerender('9e616fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/order/changeList.vue"
export default component.exports